// These discounts are promo codes that are automatically applied to certain pass types
// If no discounts currently exist, just export an empty array

import { PURCHASE_TYPES } from "./constants";

export const phlDiscounts = [
  {
    subscriptionTypeId: 251, // Pass type ID
    displayPrice: "24 hours of access for <s>$15</s> <b>$5</b>",
    promo: "FIRSTFRIDAY", // Promo code to automatically apply
    discountText: "First Friday discount!", // to be shown in pass description
    shouldApply: () => {
      const today = new Date();
      return today < new Date("2025-01-01") && today.getDay() === 5 && today.getDate() <= 7;
    },
    purchaseTypes: [PURCHASE_TYPES.new, PURCHASE_TYPES.change, PURCHASE_TYPES.renew],
  },
  {
    subscriptionTypeId: 239,
    displayPrice: "<s>$20</s> <b>$5</b> for the first month",
    promo: "INDEPRO24", // Promo code to automatically apply
    discountText: "Bike month discount!", // to be shown in pass description
    shouldApply: () => {
      const today = new Date();
      return today < new Date("2024-06-01");
    },
    purchaseTypes: [PURCHASE_TYPES.new],
  },
  {
    subscriptionTypeId: 243,
    displayPrice: "<s>$5</s> <b>$4</b> for the first month",
    promo: "INDEPRO24", // Promo code to automatically apply
    discountText: "Bike month discount!", // to be shown in pass description
    shouldApply: () => {
      const today = new Date();
      return today < new Date("2024-06-01");
    },
    purchaseTypes: [PURCHASE_TYPES.new],
  },
];
